<template>
<div class="standardSwitchChild">
  <div class="navShow">
    <i><img src="../../../assets/img/setIcon.png" alt=""></i>
    <el-breadcrumb separator=">">
      <template v-if="showChild&&JSON.stringify(tabData) == '{}'">
        <el-breadcrumb-item>
          <span class="deviceJump" @click="jumpDev">设备列表</span>
        </el-breadcrumb-item>
        <template>
          <el-breadcrumb-item>
            <span>子设备列表</span>
          </el-breadcrumb-item>
        </template>
      </template>
    </el-breadcrumb>
    <el-breadcrumb separator=">">
      <template v-if="JSON.stringify(tabData) != '{}'">
        <el-breadcrumb-item>
          <span class="deviceJump" @click="jumpDev">设备列表</span>
        </el-breadcrumb-item>
        <template>
          <el-breadcrumb-item>
            <span class="deviceJumpChild" @click="jumpDevChild">子设备列表</span>
          </el-breadcrumb-item>
        </template>
        <template>
          <el-breadcrumb-item><span>{{devcieIdCode}}</span></el-breadcrumb-item>
        </template>
        <template>
          <el-breadcrumb-item><span>{{tabData.name}}</span></el-breadcrumb-item>
        </template>
      </template>
    </el-breadcrumb>
  </div>
  <div class="devcieContainer" :style="styleObject" v-if="JSON.stringify(tabData) == '{}'">
    <div class="container">
      <div class="query">
        <div class="queryCons">
          <!-- <div class="common">
            <el-input placeholder="安装位置" autocomplete="off" v-model="searchText"></el-input>
            <div class="search" @click="serachData">
              <i><img src="../../../assets/img/searchIcon.png" alt=""></i>
            </div>
          </div> -->
          <el-select class="common" v-model="keyWords.isOnline" placeholder="在线状态" clearable @change="isOnlineChange">
            <el-option label="离线" :value="0"></el-option>
            <el-option label="在线" :value="1"></el-option>
          </el-select>
          <el-select class="common" v-model="keyWords.isAlarm" placeholder="报警状态" clearable @change="isAlarmChange">
            <el-option label="正常" :value="0"></el-option>
            <el-option label="报警中" :value="1"></el-option>
          </el-select>
          <el-select class="common" v-model="keyWords.isFault" placeholder="是否故障" clearable @change="isFaultChange">
            <el-option label="完好" :value="0"></el-option>
            <el-option label="故障" :value="1"></el-option>
          </el-select>
          <el-button  type="success" size="medium" @click="handleShowSelect(3)">远程控制</el-button>
          <el-button  type="success" size="medium" @click="handleShowSelect(200)">参数设置</el-button>
          <!-- <button class="primaryBtn common" @click="serachData">搜索</button> -->
          <!-- <button class="delSome" @click="changeRightCons">
            <i class="imgShow"><img src="../../../assets/img/statistics.png" alt=""></i>
            <span>实时统计</span>
          </button> -->
        </div>
      </div>
      <div class="listsContainer" :style="styleObjectCons">
        <div class="listsLeft">
          <div v-show="isShowSelect" class="show-sure">
            <el-checkbox v-model="allPage" size="medium" @change="handleCheckAllChange">全部</el-checkbox>
            <el-button class="sure-btn" type="primary" size="mini" @click="handleSelectPart">确定</el-button>
          </div>
          <el-scrollbar wrap-class="scrollbar-wrapper" v-loading="tableLoading">
            <ul class="clearfix cardList">
              <li v-for="(dataInfo,index) in dataList" :key="index">
                <!-- 复选框 -->
                <div class="set-icon" v-if="isShowSelect">
                  <el-checkbox v-model="dataInfo.isSelect" size="medium" :disabled="!dataInfo.isSet" />
                </div>
                <!-- 单设备布防 -->
                <span class="set-icon" @click="handleShowSet(dataInfo)" v-else>
                  <i class="el-icon-s-tools"></i>
                </span>
                <card-child @changeCards="changeCards" :info="dataInfo" @clickEven="clickEven"></card-child>
              </li>
            </ul>
          </el-scrollbar>
          <div class="noData" v-if="!(dataList&&dataList.length)&&consShow">
            <img src="../../../assets/img/noData.png" alt="">
            <div class="tip">暂无数据</div>
          </div>
          <div class="cardPage">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pagination.currentPage" :page-sizes="pagination.pageSizes" :page-size="pagination.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mainContent" :style="styleObject" v-if="JSON.stringify(tabData) != '{}'">
    <div class="tabBox">
      <tab-block @tabToggle="toggleCom" :pageType="pageType" :tabs="tabs"></tab-block>
    </div>
    <div class="main">
      <!-- <component :is="component" :deviceChildId="deviceChildId" :typeChild="typeChild"></component> -->
      <component :is="component" :deviceId="deviceChildId" type="standardSwitch" :sn="sn" :childId="childId" @jumpDev="jumpDev"></component>
    </div>
  </div>
  <!-- 设置下发 -->
  <el-dialog :title="title" :visible.sync="isShowSet" width="440px">
    <div class="dialog-box" v-if="nowType == 3">
      <el-radio-group v-model="common">
        <el-radio v-for="item in selectOptions" :key="item.value" :label="item.value">{{ item.label }}</el-radio>
      </el-radio-group>
    </div>
    <div class="dialog-box params" v-if="nowType == 200">
      <p v-for="(item, index) in paramsOptions" :key="index">
        <span>{{item.label}}</span>
        <el-switch v-model="item.value" active-text="使能" inactive-text="关闭"/>
      </p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="loadingSave" @click="handleSave">保 存</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
import TabBlock from '@/components/common/TabBlock'
import BasicInfoChild from '@/views/deviceManagement/standardSwitch/BasicInfoChild'
// import DeviceDatasChild from '@/views/deviceManagement/deviceDetails/DeviceDatas'
import AlarmRecordChild from '@/views/deviceManagement/standardSwitch/AlarmRecord'
// import FaultRecordChild from '@/views/deviceManagement/deviceDetails/FaultRecord'
// import DeviceRightCons from '@/views/deviceManagement/gatewayChild/DeviceRightCons'
import CardChild from '@/views/deviceManagement/standardSwitch/cardChild'
export default {
  name: 'standardSwitchChild',
  components: {
    TabBlock,
    BasicInfoChild,
    // DeviceDatasChild,
    AlarmRecordChild,
    // FaultRecordChild,
    CardChild,
    // DeviceRightCons
  },
  props: {
    deviceId: {
      type: Number,
      default: () => {
        return null;
      }
    },
    Psn: {
      type: [Number, String],
      default: ''
    }
  },
  data() {
    return {
      searchText: '',
      keyWords: {
        isAlarm: "",
        isFault: "",
        isOnline: ""
      },
      options: [{
        value: '1',
        label: '在线'
      }, {
        value: '0',
        label: '离线'
      }],
      component: '',
      tabs: [
        {
          name: '基本信息',
          code: 'BasicInfoChild'
        },
        // {
        //   name: '设备数据',
        //   code: 'DeviceDatasChild'
        // },
        {
          name: '报警记录',
          code: 'AlarmRecordChild'
        },
        // {
        //   name: '故障记录',
        //   code: 'FaultRecordChild'
        // }
      ],
      pageType: 'DeviceGas',
      styleObject: {
        height: ''
      },
      styleObjectCons: {
        height: ''
      },
      tabData: {},
      pagination: {
        show: true,
        currentPage: 1,
        pageSize: 15,
        pageSizes: [15, 25, 35],
        total: 0
      },
      dataList: [],
      tableLoading: true,
      deviceChildId: null,
      childId: null,
      consShow: false,
      currentTreeId: '',
      showChild: true,
      typeChild:'',
      devcieIdCode:'',
      isShowSelect: false,
      allPage: false,
      isShowSet: false,
      title: '',
      setParams: {
        sn: '',
        address: '',
        childDeviceId: '',
        val: ''
      },
      Params: {
        sn: '',
        address: '',
        childDeviceId: '',
        alarmHeaterLoad: 0,
        alarmDryerLoad: 0,
        alarmCookerLoad: 0,
        alarmPotLoad: 0,
        alarmBatteryLoad: 0,
        alarmOvenLoad: 0,
      },
      selectOptions: [
        { label: '分闸', value: 0 },
        { label: '合闸', value: 1 },
        { label: '漏电自检', value: 2 },
        { label: '清除故障', value: 3 },
        { label: '解除锁定', value: 4 },
      ],
      paramsOptions: [
        { label: '电热类负载告警', value: 0 },
        { label: '吹风机负载告警', value: 0 },
        { label: '电磁炉负载告警', value: 0 },
        { label: '保温锅负载告警', value: 0 },
        { label: '电瓶车负载告警', value: 0 },
        { label: '微波炉负载告警', value: 0 },
      ],
      common: null,
      loadingSave: false,
      sn: null,
      nowType: null
    }
  },
  created() {
    this.makeheight()
    this.makeheightCons()
    this.initData()
  },
  methods: {
    // 节点点击发生变化时，触发事件
    handleNodeSelect(item) {
      this.currentTreeId = item ? (item.value ? item.value : 0) : 0;
      this.pagination.currentPage = 1;
      this.initData();
    },
    serachData() {
      //查询//搜索
      this.searchText = this.searchText.replace(/(^\s*)|(\s*$)/g, "")
      this.pagination.currentPage = 1
      this.initData()
    },
    initData() {
      this.consShow = false
      this.params = {
        key: this.searchText,
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        // install: this.keyWords.isInstall,
        alarm: this.keyWords.isAlarm,
        fault: this.keyWords.isFault,
        // regist: this.keyWords.isRegist,
        online: this.keyWords.isOnline,
        deviceId:this.deviceId
      }
      this.request.get('/front/device/standardSwitch/child/page', this.params)
        .then(res => {
          if (res.code === 200) {
            this.tableLoading = false
            this.consShow = true
            this.dataList = res.data ? res.data : []
            this.pagination.total = res.total
          } else if (res.code === 500) {
            this.dataList = []
            this.msg.warn(res.msg)
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    jumpDev() {
      this.$emit('jumpDevice',false)
    },
    jumpDevChild(){
      this.tabData = {}
      this.initData()
    },
    toggleCom(tabCode) {
      // console.log(tabCode);
      this.tabData = tabCode
      this.component = tabCode.code
    },
    clickEven(val) {
      this.tabData = {
        name: '基本信息',
        code: 'BasicInfo'
      }
      this.deviceChildId = val.deviceId
      this.childId = val.id
      this.typeChild = val.type
      this.devcieIdCode = val.code
      this.sn = val.sn
    },
    //动态获取中间滚动高度,'height'为头部和尾部的高度之和makeheightCons
    makeheight(height = 116) {
      let _this = this;
      _this.styleObject.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObject.height = window.innerHeight - height + "px";
        })();
      };
    },
    makeheightCons(height = 176) {
      let _this = this;
      _this.styleObjectCons.height = window.innerHeight - height + "px";
      window.onresize = () => {
        return (() => {
          _this.styleObjectCons.height = window.innerHeight - height + "px";
        })();
      };
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.initData()
    },
    handleSizeChange(val) {
      this.pagination.currentPage = 1
      this.pagination.pageSize = val
      this.initData()
    },
    isInstallChange(){
      this.pagination.currentPage = 1
      this.initData()
    },
    isRegistChange(){
      this.pagination.currentPage = 1
      this.initData()
    },
    isOnlineChange(){
      this.pagination.currentPage = 1
      this.initData()
    },
    isAlarmChange(){
      this.pagination.currentPage = 1
      this.initData()
    },
    isFaultChange(){
      this.pagination.currentPage = 1
      this.initData()
    },
    changeCards(val){
      if(val){
        let num = ''
        if (this.pagination.total > this.pagination.pageSize) {
          num = (this.pagination.total - this.dataList.length) % this.pagination.pageSize
          if (num == 0) {
            if(this.pagination.currentPage>1){
              this.pagination.currentPage = this.pagination.currentPage - 1                    
            }
          }
        }
        this.initData()
      }
    },
    /**
     * @Description 设备批量下发
     * @Author      YOYO     -             2022-08-05
     */
    handleShowSelect (t) {
      let msg = t == 3 ? '远程控制' : '设置参数'
      if (this.dataList.length <= 0) {
        return this.$message({ type: 'warning', message: `没有可${msg}的设备！`})
      }

      this.nowType = t
      this.isShowSelect = !this.isShowSelect

      this.title = `批量${msg}`
      if ( t == 3) {
        this.common = null
        this.setParams = {
          sn: this.Psn,
          address: '',
          childDeviceId: '',
          val: ''
        }
      } else {
        this.Params = {
          sn: this.Psn,
          address: '',
          childDeviceId: '',
          alarmHeaterLoad: 0,
          alarmDryerLoad: 0,
          alarmCookerLoad: 0,
          alarmPotLoad: 0,
          alarmBatteryLoad: 0,
          alarmOvenLoad: 0,
        }
      }

      this.handleCheckAllChange(false)
    },
    /**
     * @Description 本页全选
     * @Author      YOYO     -             2021-11-27
     */
    handleCheckAllChange (e) {
      let temp = JSON.parse(JSON.stringify(this.dataList))
      this.dataList = temp.map(item => {
        return {
          ...item,
          isSelect: item.breakerType == this.nowType ? e : false,
          isSet: item.breakerType == this.nowType
        }
      })
    },
    /**
     * @Description 批量下发-确定
     * @Author      YOYO     -             2022-09-14
     */
    handleSelectPart () {
      let addresss = []
      let sns = []
      this.dataList.forEach(({ isSelect, deviceId, sn, address }) => {
        if (isSelect) {
          addresss.push(address)
          sns.push(sn)
        }
      })
      if (!addresss.length) {
        return this.$message({ type: 'warning', message: '请选择设备！' })
      }

      if (this.nowType == 3) {
        this.setParams.address = addresss.join(',')
        this.setParams.childDeviceId = sns.join(',')
        this.setParams.sn = this.Psn
      } else {
        this.Params.address = addresss.join(',')
        this.Params.childDeviceId = sns.join(',')
        this.Params.sn = this.Psn
      }

      this.tip = `注意： 此操作将对您已选择的设备生效(共${addresss.length})`

      this.isShowSet = true
    },
    /**
     * @Description 单设备下发
     * @Author      YOYO     -             2022-8-4
     */    
    handleShowSet (item) {
      this.isShowSet = true
      this.title = '单设备下发'
      this.isShow = false
      this.tip = ''

      let { status, address, sn, alarmHeaterLoad, alarmDryerLoad, alarmCookerLoad, alarmPotLoad, alarmBatteryLoad, alarmOvenLoad, breakerType } = item

      this.nowType = breakerType

      if (breakerType == 3) {
        this.common = status
        this.setParams = {
          sn: this.Psn,
          address,
          childDeviceId: sn,
          val: status
        }
      } else {
        this.Params = {
          sn: this.Psn,
          address,
          childDeviceId: sn,
          alarmHeaterLoad,
          alarmDryerLoad,
          alarmCookerLoad,
          alarmPotLoad,
          alarmBatteryLoad,
          alarmOvenLoad,
        }
        this.paramsOptions[0].value = alarmHeaterLoad == 1
        this.paramsOptions[1].value = alarmDryerLoad == 1
        this.paramsOptions[2].value = alarmCookerLoad == 1
        this.paramsOptions[3].value = alarmPotLoad == 1
        this.paramsOptions[4].value = alarmBatteryLoad == 1
        this.paramsOptions[5].value = alarmOvenLoad == 1
      }
    },
    /**
     * @Description 设置保存
     * @Author      YOYO     -             2021-11-27
     */
    async handleSave () {
      let params = {}
      let url = ''
      if (this.nowType == 3) {
        if (this.common === null) return this.$message({ type: 'warning', message: '请选择要下发的选项！' })

        this.setParams.val = this.common
        params = this.setParams
        url = '/front/device/standardSwitch/command'
      } else {
        this.Params.alarmHeaterLoad = this.paramsOptions[0].value ? 1 : 0
        this.Params.alarmDryerLoad =  this.paramsOptions[1].value ? 1 : 0
        this.Params.alarmCookerLoad =  this.paramsOptions[2].value ? 1 : 0
        this.Params.alarmPotLoad =  this.paramsOptions[3].value ? 1 : 0
        this.Params.alarmBatteryLoad =  this.paramsOptions[4].value ? 1 : 0
        this.Params.alarmOvenLoad =  this.paramsOptions[5].value ? 1 : 0
        params = this.Params
        url = '/front/device/standardSwitch/commandPara'
      }


      this.loadingSave = true
      let { code, data, msg } = await this.request.get(url, params)
      this.loadingSave = false

      if (code != 200) return this.$message({ type: 'warning', message: msg })

      this.isShowSet = false
      this.isShowSelect = false
      this.allPage = false

      this.initData()
      this.$message({ type: 'success', message: '保存成功' })
    },
  }
};
</script>

<style lang="scss" scoped>
.standardSwitchChild {

  .navShow {
    margin-left: 20px;
    overflow: hidden;

    i {
      float: left;
      width: 16px;
      height: 16px;
      margin-right: 4px;

      img {
        width: 100%;
        height: 100%;
        vertical-align: unset;
      }
    }

    h3 {
      float: left;
      font-size: 16px;
      line-height: 16px;
      font-weight: 500;
      color: #7A7D81;
    }

    span {
      float: left;
      font-size: 16px;
      font-weight: 500;
      color: #7A7D81;
    }
  }

  .devcieContainer {
    margin: 20px 10px 10px 10px;
    // padding: 15px 20px;
    // background: #fff;
    box-sizing: border-box;
    overflow: auto;

    h4 {
      padding-bottom: 10px;
    }

    .container {
      padding: 0 10px 0 0px;
    }

    .query {
      padding-bottom: 10px;

      .queryCons {
        width: 100%;
        overflow: hidden;

        .common {
          float: left;
          margin-bottom: 5px;
          position: relative;
          .search{
            position: absolute;
            right: 10px;
            top: 0px;
            width: 40px;
            height: 40px;
            font-size: 0;
            z-index: 10;
            text-align: center;
            cursor: pointer;
            i{
              display: inline-block;
              width: 16px;
              height: 16px;
              cursor: pointer;
              margin-top: 12px;
              img{
                width: 100%;
                height: 100%;
              }
            }
          }
        }

        .primaryBtn {
          width: 82px;
          height: 40px;
          cursor: pointer;
          margin-right: 20px;
          font-size: 14px;
          line-height: 40px;
          border: 0;
          color: #FFFFFF;
          background: #1089FF;
          border-radius: 2px;

          &:hover {
            background: #0774e0;
          }
        }

        .delSome {
          width: 102px;
          cursor: pointer;
          float: right;
          font-size: 0;
          // line-height: 40px;
          // height: 40px;
          padding: 0 10px;
          border: 0;
          color: #FFFFFF;
          background: #1089FF;
          border-radius: 2px;
          outline: unset;
          overflow: hidden;

          &:hover {
            background: #0774e0;
          }

          .imgShow {
            float: left;
            width: 16px;
            height: 16px;
            margin: 10px 6px 0 0;

            img {
              width: 100%;
              height: 100%;
              vertical-align: middle;
            }

            &.active {
              transform: rotate(180deg);
            }
          }

          span {
            float: left;
            font-size: 14px;
            line-height: 40px;
          }
        }
      }
    }

    .listsContainer {
      overflow: hidden;
      position: relative;

      .listsLeft {
        float: left;
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 0 0 60px;
        position: relative;

        // background: #f3f3f3;
        .noData {
          position: absolute;
          top: 50%;
          left: 50%;
          margin-left: -150px;
          margin-top: -150px;
          text-align: center;

          img {
            width: 300px;
            height: 300px;
          }

          .tip {
            margin-top: 10px;
            font-size: 18px;
            color: #bbb;
          }
        }
        .show-sure {
          padding: 0 20px;
          height: 40px;
          line-height: 40px;
          background-color: #eaeaea;
          .sure-btn {
            float: right;
            margin-top: 6px;
          }
        }

        .cardList {
          height: 100%;
          width: 100%;
          position: relative;

          .set-icon {
            position: absolute;
            top: 22px;
            right: 18px;
            z-index: 1;
            font-size: 20px;
            color: #409EFF;
            cursor: pointer;
          }

          // overflow-x: hidden;
          // overflow-y: auto;
          &>li {
            float: left;
            width: 314px;
            height: 230px;
            padding: 10px;
            box-sizing: border-box;
            position: relative;
          }
        }

        .cardPage {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 50px;
          text-align: center;
          padding: 10px 0;
          box-sizing: border-box;
        }

        &.active {
          width: 100%;

          .cardList {
            height: 100%;
            width: 100%;
            overflow-x: hidden;
            overflow-y: auto;

            &>li {
              float: left;
              width: 20%;
              height: 240px;
            }
          }
        }
      }

    }
  }
  .mainContent {
    margin: 12px;
    padding: 15px 20px;
    background: #fff;
    box-sizing: border-box;
    overflow: auto;
  }
  .dialog-box {
    .el-radio {
      display: block;
      margin-top: 15px;
    }
  }
  .params {
    p {
      margin-bottom: 20px;
      span {
        display: inline-block;
        width: 150px;
      }
    }
  }

  @keyframes slid-open {
    0% {
      transform: translateX(100%);
      opacity: 0;
    }

    100% {
      transform: translateX(0);
    }
  }

  @keyframes slid-out {
    0% {
      width: 600px;
      transform: translateX(0)
    }

    100% {
      transform: translateX(100%)
    }
  }
}
</style><style lang="scss">
.standardSwitchChild {
  .el-checkbox__inner {
    border-radius: 50%;
    width: 20px;
    height: 20px;
    &::after {
      height: 9px;
      left: 6px;
      top: 3px;
      width: 5px;
    }
  }
  .devcieContainer {
    position: relative;
    .query {
      padding-left: 10px;

      .el-input {
        width: 260px;
        margin-right: 10px;
        .el-input__inner {
          line-height: 40px;
          height: 40px;
          border:none;
          outline: none;
        }
      }

      .el-select {
        width: 170px;
        margin-right: 10px;

        .el-input {
          width: 170px;
          margin-right: 10px;

          .el-input__inner {
            line-height: 40px;
            height: 40px;
            border:none;
            outline: none;
          }
        }
      }
    }

    .el-loading-mask {
      background-color: unset;
    }
  }

  .el-breadcrumb {
    display: inline-block;
    padding: 0;
    font-family: AlibabaPuHuiTi-Medium;
    .deviceJump{
      cursor: pointer;
    }
    .deviceJumpChild{
      cursor: pointer;
    }
  }

  .el-breadcrumb__inner a,
  .el-breadcrumb__inner.is-link {
    color: #7A7D81;
    font-size: 16px;
    font-weight: 500;
  }

  .el-breadcrumb__separator {
    font-size: 16px;
    color: #7A7D81;
    margin: 0 5px;
    font-weight: 500;
  }

  .el-breadcrumb__inner {
    font-size: 16px;
    color: #7A7D81 !important;
    font-weight: 500 !important;
    line-height: 16px;
  }
}
</style>
